// extracted by mini-css-extract-plugin
module.exports = {"iconWrapper":"rR","hide":"rS"};